

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';

import { OverlayModule } from '@angular/cdk/overlay';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { IcalcComponent } from './icalc';

import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';

import { ICalcDirective } from './icalc.directive';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        OverlayModule,
        NzIconModule,
        NzRadioModule,
        NzCheckboxModule
    ],
    declarations: [
        IcalcComponent,
        ICalcDirective
    ],
    exports: [
        IcalcComponent,
        ICalcDirective
    ],
    schemas:[
        CUSTOM_ELEMENTS_SCHEMA
    ]
})

export class IcalcModule { }